module.exports = __webpack_public_path__ + "img/9788956372594.1c8a7226.jpg";